export const INTERNAL_NETWORK_TUNNEL_PATH_NAME = 'internal-network-tunnel';
export const INTERNAL_NETWORK_TUNNEL_WS_PATH = `/${INTERNAL_NETWORK_TUNNEL_PATH_NAME}/ws`;
export const INTERNAL_NETWORK_TUNNEL_PUBLIC_WS_PATH = `/gateway${INTERNAL_NETWORK_TUNNEL_WS_PATH}`;

export const isInternalNetworkTunnelWsPath = (path: string): boolean =>
  path === INTERNAL_NETWORK_TUNNEL_WS_PATH ||
  path === INTERNAL_NETWORK_TUNNEL_PUBLIC_WS_PATH;
export const INTERNAL_NETWORK_TUNNEL_SESSION_TTL_SECONDS = 4 * 60 * 60;
export const INTERNAL_NETWORK_TUNNEL_CONNECTION_HEARTBEAT_TTL_SECONDS = 30;
export const INTERNAL_NETWORK_TUNNEL_PENDING_ATTACH_TTL_SECONDS = 60;
export const INTERNAL_NETWORK_TUNNEL_ORPHAN_GRACE_SECONDS = 150;
export const INTERNAL_NETWORK_TUNNEL_MAX_SESSIONS_PER_USER = 2;
export const INTERNAL_NETWORK_TUNNEL_MAX_SESSIONS_PER_TENANT = 8;
export const INTERNAL_NETWORK_TUNNEL_MAX_STREAMS_PER_SESSION = 32;
export const INTERNAL_NETWORK_TUNNEL_MAX_STREAM_OPENS_PER_MINUTE = 120;
export const INTERNAL_NETWORK_TUNNEL_MAX_FRAME_PAYLOAD_BYTES = 256 * 1024;
export const INTERNAL_NETWORK_TUNNEL_MAX_BYTES_PER_STREAM =
  2 * 1024 * 1024 * 1024;
export const INTERNAL_NETWORK_TUNNEL_CLIENT_BUFFER_HIGH_WATER_BYTES =
  4 * 1024 * 1024;
export const INTERNAL_NETWORK_TUNNEL_CLIENT_BUFFER_LOW_WATER_BYTES =
  1024 * 1024;
export const INTERNAL_NETWORK_TUNNEL_LEASE_KEEPALIVE_MS = 60_000;
export const INTERNAL_NETWORK_TUNNEL_LEASE_REFRESH_FAILURE_LIMIT = 3;
export const INTERNAL_NETWORK_TUNNEL_SESSION_LIVENESS_MS = 5_000;
export const INTERNAL_NETWORK_TUNNEL_BROKER_FLAG =
  'INTERNAL_NETWORK_TUNNEL_BROKER_ENABLED';
export const INTERNAL_NETWORK_TUNNEL_SUBPROTOCOL =
  'terra.internal-network-tunnel.v1';
